import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["list", "input"]
  static values = {
    url: String,
    currentTimeout: Number
  }

  search() {
    const query = this.inputTarget.value
    const newTimeout = setTimeout(() => this._search(query), 300)
    clearTimeout(this.currentTimeoutValue)
    this.currentTimeoutValue = newTimeout
  }

  _search(query) {
    this.listTarget.src = `${this.urlValue}?query=${query}`
  }
}
